import moment from "moment";

export const formatDateByLanguage = (
  dateString: string | undefined | null,
  lang: string
) => {
  let response = "";
  try {
    const format = lang === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY";
    if (dateString && moment(dateString).isValid())
      response = moment(dateString).format(format);
  } catch (err) {
    console.error("Error on format date by language", dateString, lang, err);
  } finally {
    return response;
  }
};
